import React, { FC } from 'react';
import { EmmaText } from '@axa-asia/emma-stylesheet';
import { ADDRESS_ABBREVIATION_MAPPING } from '../../../../../constants/constants';
import './styles.scss';
import { useSelector } from 'react-redux';
import { getAddressAbbreviationLabel } from '../../../selectors/changeAddressSelector';
import { resolveLocalizedText } from '../../../../../utils';
import classNames from 'classnames';

type AddressAbbreviationListProps = {
  tableHeaderClassName?: string;
};

type AddressAbbreviationListItemProps = {
  type: string;
  abbreviation: string;
};

const AddressAbbreviationListItem: FC<AddressAbbreviationListItemProps> = ({
  type,
  abbreviation,
}) => {
  return (
    <div className="addressAbbreviationList-listItem">
      <div className={EmmaText['BodyTextS/line-15em/Left/MineShaft']}>
        {type}
      </div>
      <div className={EmmaText['BodyTextS/line-15em/Left/MineShaft']}>
        {abbreviation}
      </div>
    </div>
  );
};

const AddressAbbreviationList: FC<AddressAbbreviationListProps> = ({
  tableHeaderClassName,
}) => {
  const { type, abbreviation } = useSelector(getAddressAbbreviationLabel);
  return (
    <div>
      <div
        className={classNames(
          'addressAbbreviationList-tableHeader',
          tableHeaderClassName,
        )}
      >
        <div className={EmmaText['Title_L/LooseContent/Left/MineShaft']}>
          {resolveLocalizedText(type)}
        </div>
        <div className={EmmaText['Title_L/LooseContent/Left/MineShaft']}>
          {resolveLocalizedText(abbreviation)}
        </div>
      </div>
      {ADDRESS_ABBREVIATION_MAPPING.map((item) => (
        <AddressAbbreviationListItem
          key={item.Type}
          type={item.Type}
          abbreviation={item.Abbreviation}
        />
      ))}
    </div>
  );
};

export default AddressAbbreviationList;
